import { autoinject } from 'aurelia-framework';
import { EnvironmentService } from 'app/shared/services/environment-service';
import { EventAggregator, Subscription } from 'aurelia-event-aggregator';
import { SessionChangedEvent } from 'app/shared/lib/session/session-events';
import { AppSession } from 'app/shared/lib/session/session';
import { EssDropdownCustomElement } from 'app/shared/elements/ess-dropdown';
import { guid } from 'app/shared/lib/guid';

@autoinject
export class EssUserIcon {

    protected eventSubscription: Subscription | null = null;
    protected $userPanelDropdown!: EssDropdownCustomElement;
    protected id: guid = guid();

    protected handleSessionChanged = ({ hasUserLoggedOut }: SessionChangedEvent) => {
        if(hasUserLoggedOut) {
            this.$userPanelDropdown.close();
        }
    };

    constructor(
        protected readonly events: EventAggregator,
        protected readonly env: EnvironmentService,
        protected readonly session: AppSession) {
    }

    protected attached(): void {
        this.eventSubscription = this.events.subscribe(SessionChangedEvent, this.handleSessionChanged);
    }

    protected detached(): void {
        this.eventSubscription?.dispose();
    }

    protected handleUserAction(): true {
        this.$userPanelDropdown.close();
        return true;
    }

    protected initials(first: string | null, middle: string | null, last: string | null): string {
        const results: string[] = [];
        if(first) { results.push(first.substr(0, 1)); }
        if(middle) { results.push(middle.substr(0, 1)); }
        if(last) { results.push(last.substr(0, 1)); }
        return results.join('');
    }
}
